import Auth from "../Auth";
import Model from "./Model";
import Opportunity from "./Opportunity";
import IsOpportunityTraits from "./decorators/IsOpportunityTraits"

import TalentPortal from "../views/talent-portal/TalentPortal";
import User from "./User";
import ProjectPosition from "./ProjectPosition";
import Team from "./Team";
import Project from "./Project";
import Client from "./Client";
import Document from "./Document";
import UserDiscipline from "./UserDiscipline";
import {generatePath, useNavigate} from "react-router-dom";
import {useAuth} from "../providers/AuthProvider";
import {useMutation} from "@tanstack/react-query";
import {useAPI} from "../config/API";

// const Opportunity.Statuses = {
//     Interested: 'Shown Interest',
//     Invited: 'Invited',
//     AwaitingTeamApproval: 'Awaiting Team Approval',
//     Proposing: 'Proposing',
//     PendingContract: 'Pending Contract',
//     Active: 'Active',
//     Lost: 'Lost',
//     Declined: 'Declined',
//     Complete: 'Complete',
//     Withdrawn: 'Withdrawn',
//     // Cancelled: 'Cancelled',
// }

// const ProjectType = {
//     Service: 'Service-Based',
//     BYO: 'Build Your Own',
// }

export default class AgencyOpportunity extends IsOpportunityTraits(Model)
{
    static Key = 'AgencyOpportunity';

    oppListWithSimilarStatus() {
        return TalentPortal.supplierClientProjectsListPath(this.displayStatus())
    }

    detailLink() {
        return generatePath('/supplier/project/:oppId', {oppId: this.id})
    }
    proposalLink() {
        return this.detailLink()
    }
    resolve() {
        if (this.hasWonProject() && this.winningResource()) {
            this.matching_talent = [this.winningResource()]
        }

        return this;
    }

    static normalize(props)
    {

        // props.last_viewed_at = TB.moment().subtract(6, 'months').toISOString();
        props.last_viewed_at = TB.moment();
        if (props.project_position) {
            props.project_position = ProjectPosition.make({...props.project_position});

            if (props.project?.positions?.length) {
                props.project.positions = TB.map([...props.project.positions], position => {
                    if (position.id === props.project_position.id) {
                        return {
                            ...position,
                            assigned: {
                                user: {...(TB.auth().user() || {})},
                                disciplines: position.disciplines
                            }
                        };
                    }
                    return position
                })
            }
        }

        if (props.accepted_at && !props.withdrew_at) {
            let brief_steps = [
                'accepted_scope_at',
                'accepted_terms_at',
                'accepted_schedule_at',
                'accepted_payout_at',
                'accepted_role_skills_at',
                'accepted_client_project_overview_at',
                'accepted_deliverables_at',
            ];
            TB.map(brief_steps, step => {
                props[step] = props.accepted_at;
            })
        }

        if (props.team) {
            props.team = Team.make({...props.team})
        }
        if (props.talent_user) {
            props.talent_user = User.make({...props.talent_user})
        }
        if (props.project?.team) {
            props.project.team = Team.make({...props.project.team})
        }

        if (props.project) {
            props.project = Project.make({...props.project})
        }
        if (props.client) {
            props.client = Client.make({...props.client})
        }

        if (props.latest_contract) {
            props.latest_contract = Document.make({...props.latest_contract})
        }

        if (props.latest_signed_contract) {
            props.latest_signed_contract = Document.make({...props.latest_signed_contract})
        }

        if (props.latest_proposal) {
            props.latest_proposal = Document.make({...props.latest_proposal})
        }
        if (props.talent_uploaded_proposals) {
            props.talent_uploaded_proposals = Document.makeMany([...props.talent_uploaded_proposals])
        }

        if (props.disciplines?.length > 0) {
            props.disciplines = UserDiscipline.makeMany(props.disciplines)
        }
        if (props.matching_talent) {
            let matchedTalent = TB.map(props.matching_talent,
                talentOpp => Opportunity.make({
                    id: talentOpp?.job_candidate?.id,
                    ...talentOpp,
                    project_position: props.project_position,
                    project: props.project,
                    for_agency: true,
                    user: talentOpp.user ? User.make(talentOpp.user) : null,
                    team: talentOpp.team ? Team.normalizeScope(Team.make({...talentOpp.team, job_candidate: talentOpp.job_candidate}), props.project) : null,
            }))
            props.matching_talent = matchedTalent;
            props.matching_talent = TB.orderBy(matchedTalent, opp => {
                if (opp.job_candidate?.talent_rejected_at || opp.job_candidate?.talent_withdrew_at) return 0;
                switch (opp.status) {
                    case Opportunity.Statuses.Lost:
                    case Opportunity.Statuses.Declined:
                    case Opportunity.Statuses.Withdrawn:
                    case 'Lost / Declined':
                        return 0;
                    default:
                    case Opportunity.Statuses.Interested:
                        return 1
                    case Opportunity.Statuses.Invited:
                    case 'Invited (new)':
                        return 2;
                    case Opportunity.Statuses.Proposing:
                        return 3;
                    case Opportunity.Statuses.AwaitingTeamApproval:
                    case Opportunity.Statuses.PendingContract:
                        return 4;
                    case Opportunity.Statuses.Active:
                        return 5;
                    case Opportunity.Statuses.Complete:
                        return 6
                }
            }, 'desc')
        }
        return props;
    }

    static FetchAllForSupplierResourceManagerRequest;

    static async fetchAllForSupplierResourceManager(params = {}, requestOptions = {})
    {
        let user = Auth.registeredSupplierClientResourceManager();
        if (!user) {
            return;
        }

        this.FetchAllForSupplierResourceManagerRequest = TB.request(
            TB.api_endpoint(`/api/talent-agency-opportunities`),
            params
        );

        let response = await this.FetchAllForSupplierResourceManagerRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunities')) {
            return;
        }

        return this.makeMany([...response.success.data.opportunities]);
    }

    static FetchRequest;

    static async fetchDetails(oppId, requestOptions = {})
    {
        let user = Auth.registeredSupplierClientResourceManager();
        if (!user || !oppId) {
            throw new Error("Unauthorized")
        }

        this.FetchRequest = TB.request(
            TB.api_endpoint(`/api/talent-agency-opportunities/${oppId}`)
        );

        let response = await this.FetchRequest.get(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Unable to load opportunity")
        }

        return this.make(response.success.data.opportunity);
    }

    static CreateForProjectPositionRequest;

    static async createForProjectPosition(positionId, requestOptions = {})
    {
        let user = Auth.registeredSupplierClientResourceManager();
        if (!user || !positionId) {
            throw new Error("Unauthorized")
        }

        this.CreateForProjectPositionRequest = TB.request(
            TB.api_endpoint(`/api/talent-agency-opportunities/positions/${positionId}/store`)
        );

        let response = await this.CreateForProjectPositionRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Unable to create opportunity")
        }

        return this.make(response.success.data.opportunity);
    }

    static CreateForProjectTeamRequest;

    static async createForProjectTeam(projectId, requestOptions = {})
    {
        let user = Auth.registeredSupplierClientResourceManager();
        if (!user || !projectId) {
            throw new Error("Unauthorized")
        }

        this.CreateForProjectTeamRequest = TB.request(
            TB.api_endpoint(`/api/talent-agency-opportunities/projects/${projectId}/teams/store`)
        );

        let response = await this.CreateForProjectTeamRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Unable to create opportunity")
        }

        return this.make(response.success.data.opportunity);
    }

    static CreateForProjectEngagementLeadRequest;

    static async createForProjectEngagementLead(projectId, requestOptions = {})
    {
        let user = Auth.registeredSupplierClientResourceManager();
        if (!user || !projectId) {
            throw new Error("Unauthorized")
        }

        this.CreateForProjectEngagementLeadRequest = TB.request(
            TB.api_endpoint(`/api/talent-agency-opportunities/projects/${projectId}/engagement-leads/store`)
        );

        let response = await this.CreateForProjectEngagementLeadRequest.post(requestOptions).catch(console.warn);

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Unable to create opportunity")
        }

        return this.make(response.success.data.opportunity);
    }

    static UpdateRequest;

    static async update(opportunity, props)
    {
        this.cancelRequest('UpdateRequest');

        this.UpdateRequest = TB.request(
            TB.api_endpoint(
                `/api/talent-agency-opportunities/${opportunity.id}/update`
            ), props
        );

        if (TB.filter(TB.values(props), value => value instanceof File).length) {
            this.UpdateRequest = this.UpdateRequest.headers({
                'Content-Type': 'multipart/form-data'
            })
        }
        let response = await this.UpdateRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);

        return updatedOpp
    }

    updateMatchingForTalent = async(job, user, props) => {

        let updateProps = {
            talent_user_id: user.id
        };

        if (props.skills?.length) {
            let skills = user.skills || [];

            let skillsToAdd = props.skills || [];
            skills = TB.filter([...skills], skill => !TB.includes(TB.map(skillsToAdd, 'id'), skill.id));

            updateProps.skills = TB.map([
                ...skills,
                ...skillsToAdd
            ], skill => {
                let item = TB.pick(skill, ['id', 'self_score'])
                item.self_score = parseInt(item.self_score)
                return item
            });

        }
        if (props.industries?.length) {
            let industries_worked = user.industries_worked || [];

            let industries = props.industries || [];
            industries_worked = TB.filter(industries_worked, industry => !TB.includes(TB.map(industries, 'id'), industry.id));

            updateProps.industries_worked = TB.map([
                ...industries_worked,
                ...industries
            ], industry => {
                let item = TB.pick(industry, ['id', 'self_score'])
                item.self_score = parseInt(item.self_score)
                return item
            });
        }

        if (props.disciplines?.length) {
            let talent_disciplines = user.talent_disciplines || [];

            let disciplines = props.disciplines || [];
            talent_disciplines = TB.filter(talent_disciplines, discipline => !TB.includes(TB.map(disciplines, 'id'), discipline.id));

            updateProps.talent_disciplines = TB.map([
                ...talent_disciplines,
                ...disciplines
            ], dis => {
                let item = TB.pick(dis, ['id', 'self_score'])
                item.self_score = parseInt(item.self_score)
                return item
            });
        }

        const updateForProjectPositionMatchingRequest = TB.request(
            TB.api_endpoint(`/api/talent-project-positions/${this.project_position?.id}/update-matching`),
            updateProps
        )

        let response = await updateForProjectPositionMatchingRequest.post()
            .catch(console.warn);

        console.log("update_matching", response)
        if (!response || !TB.has(response, 'success.data.project_position')) {
            return false;
        }

        let updatedJob = ProjectPosition.make({...response.success.data.project_position})

        let updatedOpp = AgencyOpportunity.make({
            ...this,
            matching_talent: TB.map(this.matching_talent, talentUserOpp => {
                if (talentUserOpp.user?.id === user.id) {
                    return {
                        ...talentUserOpp,
                        matching: {...updatedJob.matching}
                    }
                }
                return talentUserOpp
            })
        })
        return updatedOpp
    }

    static WithdrawRequest;

    static async withdraw(opportunity)
    {
        if (!opportunity.can_be_withdrawn) {
            throw new Error("Opportunity cannot be withdrawn")
        }
        this.WithdrawRequest = TB.request(
            TB.api_endpoint(
                `/api/job-candidates/${opportunity.id}/withdraw-for-talent?for_agency=1`
            )
        );

        let response = await this.WithdrawRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);

        return updatedOpp
    }
    static RejectRequest;

    static async reject(opportunity, params = {})
    {
        if (!opportunity.can_be_rejected) {
            throw new Error("Opportunity cannot be rejected")
        }
        this.RejectRequest = TB.request(
            TB.api_endpoint(
                `/api/job-candidates/${opportunity.id}/reject-for-talent?for_agency=1`
            ), params
        );

        let response = await this.RejectRequest.post().catch(e => {
            console.warn("UPDATE", e)
        });

        if (!TB.has(response, 'success.data.opportunity')) {
            throw new Error("Something went wrong")
        }

        let updatedOpp = this.make(response.success.data.opportunity);

        return updatedOpp
    }

    hasWonProject = () => {
        return this.isPendingContract() || this.isActive() || this.isCompleted()
    }
    winningResource = () => {
        if (!this.hasWonProject()) {
            return false
        }
        return TB.find(this.matching_talent, (talentUserOpp) => {
            return talentUserOpp.isPendingContract() || talentUserOpp.isActive() || talentUserOpp.isCompleted()
        })
    }

    statusColor()
    {
        if (!this.id) {
            return this.is_match ? TB.config('color.success') : TB.config('color.warning')
        }
        switch (this.status) {
            case Opportunity.Statuses.Invited:
            case Opportunity.Statuses.Proposing:
            case Opportunity.Statuses.AwaitingTeamApproval:
            case Opportunity.Statuses.PendingContract:
                if (this.project.is_on_hold) {
                    return TB.config('color.disabled')
                }
                break;
        }

        return Opportunity.colorForStatus(this.status);
    }

    statusClass()
    {
        return Opportunity.classForStatus(this.status);
    }
}

const fetchAllForSupplierResourceManager = async({queryKey, signal}) => {
    const params = queryKey[1] || {}
    return AgencyOpportunity.fetchAllForSupplierResourceManager(params, {signal})
}
const fetchOpportunity = async({queryKey, signal}) => {
    const oppId = queryKey[1] || {}
    return AgencyOpportunity.fetchDetails(oppId, {signal})
}
const createOpportunityForProjectPosition = async(positionId,props) => {
    return AgencyOpportunity.createForProjectPosition(positionId, props)
}
const createTeamOpportunityForProject = async(projectId,props) => {
    return AgencyOpportunity.createForProjectTeam(projectId, props)
}
const createEngagementLeadOpportunityForProject = async(projectId,props) => {
    return AgencyOpportunity.createForProjectEngagementLead(projectId, props)
}
const updateOpportunity = async(opportunity, props) => {
    return AgencyOpportunity.update(opportunity, props)
}
const withdrawOpportunity = async(opportunity, props = {}) => {
    return AgencyOpportunity.withdraw(opportunity, props)
}

const rejectOpportunity = async(params) => {
    let {
        opportunity, props = {}
    } = params
    return AgencyOpportunity.reject(opportunity, props)
}


const useTalentResourceFilters = () => {
    const {auth} = useAuth();

    return useAPI(['fetchTalentResourcesForJobBoard', auth.clientOrg?.()?.id],
         {
            enabled: auth && auth.clientOrg && auth.canManageClientResourceTalent()
        })
};
const useCreateAgencyOpportunityMutation = () => {
    const navigate = useNavigate();

    return useMutation(['createSupplierOpportunity'],  (position) => {
        return createOpportunityForProjectPosition(position?.id)
    }, {

        onSuccess: (opportunity) => {
            console.log('onSuccess', opportunity);

            return navigate({
                pathname: `/supplier/project/${opportunity.id}`,
                search: "?firstTime=1"
            })
        },
        onError: e => {
            console.log('onError', e);
            return TB.showServerErrorToast();
        }
    })
}

export {
    fetchAllForSupplierResourceManager,
    fetchOpportunity,
    useTalentResourceFilters,
    useCreateAgencyOpportunityMutation,
    createOpportunityForProjectPosition,
    createTeamOpportunityForProject,
    createEngagementLeadOpportunityForProject,
    rejectOpportunity,
    updateOpportunity,
    withdrawOpportunity,
}